import { Link, useSearchParams } from "react-router-dom";
import { tourForRole } from "../tour/scripts";
import { useTourPlayer } from "../tour/useTourPlayer";

export default function GuidedTour() {
  const [params] = useSearchParams();
  const role = params.get("role") === "broker" ? "broker" : "agent";
  const userId = params.get("user") || "";
  const tour = tourForRole(role);
  const player = useTourPlayer(tour.sections, { role, userId });

  return (
    <article>
      <p className="muted">
        <Link to={`/support?role=${role}${userId ? `&user=${encodeURIComponent(userId)}` : ""}`}>
          Back to support
        </Link>
      </p>
      <h1>{tour.title}</h1>
      <p className="lead">
        {tour.duration}. Voice uses this browser for now — no background music. The recorded tour
        will replace these scripts.
      </p>
      {player.completed ? (
        <p className="confirm">First full viewing is complete. You may jump to any section.</p>
      ) : (
        <p className="muted">Jump-ahead stays locked until you finish the tour once.</p>
      )}

      <div className="tour-layout">
        <aside className="tour-nav">
          <h2>Sections</h2>
          {tour.sections.map((section, index) => (
            <button
              key={section.id}
              type="button"
              className={player.index === index ? "is-current" : ""}
              disabled={!player.canJump(index)}
              onClick={() => player.jump(index)}
            >
              {section.nav}
            </button>
          ))}
        </aside>
        <section className="tour-stage">
          <h2>{player.section.title}</h2>
          <p>{player.section.script}</p>
          <p className="pointer-hint">{player.section.pointer}</p>
          <div className="tour-controls">
            {player.playing ? (
              <button type="button" className="btn" onClick={player.pause}>
                Pause
              </button>
            ) : (
              <button type="button" className="btn" onClick={player.play}>
                Play
              </button>
            )}
            <button type="button" className="btn btn-ghost" onClick={player.nextSection}>
              Next
            </button>
            <label>
              <input
                type="checkbox"
                checked={player.muted}
                onChange={(event) => player.setMuted(event.target.checked)}
              />{" "}
              Mute
            </label>
            <label>
              Volume
              <input
                type="range"
                min="0"
                max="1"
                step="0.05"
                value={player.volume}
                onChange={(event) => player.setVolume(Number(event.target.value))}
              />
            </label>
          </div>
        </section>
      </div>
    </article>
  );
}
